export const commonEnvironment = {
  version: require('../../package.json').version
};
